import Hero from "../../components/Hero/Hero";
import React, { useEffect, useState } from "react";
import { DynamicComponentRenderer } from "./HomeMapper";
import HomeSkeleton from "./components/HomeSkeleton/HomeSkeleton";
import Newsletter from "../../components/Newsletter/Newsletter";
import PartnerPromo from "../../components/PartnerPromo/PartnerPromo";
import HomeSEO from "../../components/SEO/HomeSEO";
import { getHomeInfo, HomeInfoData } from "../../lib/getHomeInfo";
import styles from "./Home.module.css"; // Import styles for the hidden H1

const Home = () => {
  const [homeContent, setHomeContent] = useState<HomeInfoData>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHomeContent = async () => {
      try {
        setLoading(true); // Set loading to true before fetching
        const data = await getHomeInfo();

        // Console log the SEO data received from the API
        console.log("Home page received SEO data:", data.seo);

        setHomeContent(data);
        setLoading(false); // Set loading to false after fetching
      } catch (error) {
        console.error("Error fetching homepage content:", error);
        setLoading(false); // Set loading to false in case of error
      }
    };

    fetchHomeContent();
  }, []);

  const {
    homebanner = [],
    pageContent = [],
    newsletter,
    partnerPromo,
    seo,
  } = homeContent;

  console.log("homebanner data:", homebanner);

  // Show skeleton while loading
  if (loading) return <HomeSkeleton />;

  return (
    <>
      {/* Add HomeSEO component with seo data */}
      <HomeSEO seoData={seo} />

      <div>
        {/* Hidden H1 for SEO */}
        <h1 className={styles.seoHeading}>
          Evefant - Marketplace de productos para celebraciones
        </h1>

        <Hero banners={homebanner} />

        {pageContent.map((component: any, index: number) => (
          <div key={`container-${index}`}>
            <DynamicComponentRenderer component={component} />
          </div>
        ))}

        {/* Add PartnerPromo component with Spanish content */}
        {partnerPromo && (
          <PartnerPromo
            partnerQuantity={50}
            partnerQuantityText="PARTNERS YA CONFÍAN EN EVEFANT.COM"
            title="¿Tienes un negocio de productos o servicios para fiestas o celebraciones?"
            text="Descubre todos los beneficios de estar en Evefant."
            buttonText="¡Descrúbrelo aquí!"
            buttonUrl={partnerPromo.buttonUrl || "/become-partner"}
          />
        )}

        {/* Add Newsletter component at the end of the page */}
        {newsletter && (
          <Newsletter
            title={newsletter.title}
            text={newsletter.text}
            buttonText={newsletter.buttonText}
            iconUrl={newsletter.icon?.url}
          />
        )}
      </div>
    </>
  );
};

export default Home;
